"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridSession = void 0;
/* eslint-disable complexity */
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const events_1 = require("../../../security/events");
class MbHybridSession extends web_ui_security_1.BaseSession {
    constructor(sessionStorage, refreshToken) {
        super(sessionStorage);
        this.doRefresh = async () => {
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const accessToken = await this.refreshToken();
                (0, events_1.publishRefreshedSessionEvent)({ accessToken });
                return Promise.resolve({ accessToken });
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken) {
                return true;
            }
            return false;
        };
        this.refreshToken = refreshToken;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback);
    }
}
exports.MbHybridSession = MbHybridSession;
//# sourceMappingURL=index.js.map